import { render, staticRenderFns } from "./GlobalSidebar.vue?vue&type=template&id=b08bb168&scoped=true&"
import script from "./GlobalSidebar.vue?vue&type=script&lang=js&"
export * from "./GlobalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSidebar.vue?vue&type=style&index=0&id=b08bb168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08bb168",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VDivider,VIcon,VList,VListItem,VListItemAvatar,VListItemIcon,VListItemTitle,VNavigationDrawer,VTooltip})
